// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"1e25c691","406":"10d7a922","424":"362da0c5","595":"e1df8256","882":"1c5a7c0b","999":"e6e3cf9d"}[chunkId] + ".chunk.js";
};